import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center relative h-full"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", { class: "icon w-[5.313rem] h-5 text-black" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#logofull" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-center" }, "Post not found.", -1)
const _hoisted_6 = {
  key: 1,
  class: "flex relative h-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MiniPlayerComponent = _resolveComponent("MiniPlayerComponent")!
  const _component_MiniShareOverlayComponent = _resolveComponent("MiniShareOverlayComponent")!
  const _component_MiniPlayerLoadingComponent = _resolveComponent("MiniPlayerLoadingComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-container h-screen", _ctx.getTheme])
  }, [
    (!_ctx.post && _ctx.error === _ctx.PostNotFoundError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.getHideLogo)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.portalShareURL,
                target: "_blank",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackClickOut('postErrorLogo'))),
                class: "mb-1"
              }, _hoisted_4, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.post)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_MiniPlayerComponent, {
            showShareOverlay: _ctx.showShareOverlay,
            appearance: _ctx.appearance,
            showLink: _ctx.showLink
          }, null, 8, ["showShareOverlay", "appearance", "showLink"]),
          (_ctx.isShareOverlayVisible)
            ? (_openBlock(), _createBlock(_component_MiniShareOverlayComponent, {
                key: 0,
                hideShareOverlay: _ctx.hideShareOverlay,
                isPostShare: true,
                showLink: _ctx.showLink
              }, null, 8, ["hideShareOverlay", "showLink"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_MiniPlayerLoadingComponent, { key: 2 }))
  ], 2))
}